/** Design FTO 报告阅读后的分享/导出按钮引导 service。 */
export interface DesignFtoReportOnboardingService {
    /** 初始化当前 Design FTO 报告页面作用域内的引导。 */
    initialize(): void;
    /** 通知 service 当前任务已经在真实领域边界上生成报告成功。 */
    notifyReportGenerated(taskId: string): void;
    /** 消费当前仍激活的报告操作引导归因；仅首次有效点击返回 true。 */
    consumeActionGuide(): boolean;
    /** 仅供本地开发环境强制启动报告操作引导；export 为 actions 的兼容别名。 */
    debugStart(taskId: string, stage?: 'actions' | 'export'): void;
    /** 清理 Driver、按钮动画、监听器和定时器。 */
    destroy(): void;
}

/** Design FTO 报告 onboarding service 的容器标识。 */
export const DesignFtoReportOnboardingService = Symbol('DesignFtoReportOnboardingService');
